import { render, staticRenderFns } from "./RipaCpraReportHistory.vue?vue&type=template&id=fa425990"
import script from "./RipaCpraReportHistory.vue?vue&type=script&lang=js"
export * from "./RipaCpraReportHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports